import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "position-relative" }
const _hoisted_2 = {
  key: 1,
  class: "my-3"
}
const _hoisted_3 = { class: "caption text-primary-orange" }

import { onUnmounted, ref, computed } from 'vue'
  import UserInfoFormEnum from '@/config/UserInfoFormEnum'

  // common components
  import ContainerBox from '@/components/LoginRegister/common/ContainerBox/v1/ContainerBox.vue'
  import Overlay from '@/components/LoginRegister/common/Overlay/v1/Overlay.vue'
  import Banner from '@/components/LoginRegister/common/Banner/v1/Banner.vue'

  // form components
  import CheckForm from '@/components/LoginRegister/CheckForm.vue'
  import LoginForm from '@/components/LoginRegister/LoginForm.vue'
  import ResetForm from '@/components/LoginRegister/ResetForm.vue'
  import RegisterForm from '@/components/LoginRegister/RegisterForm.vue'
  import NewPasswordForm from '@/components/LoginRegister/NewPasswordForm.vue'
  import ResetPopUp from '@/components/LoginRegister/ResetPopUp.vue'

  // state
  import current_form from '@/state/current_form'
  import email from '@/state/email'
  import loadingSet from '@/state/loadingSet'
  import showResetPopUp from '@/state/showResetPopUp'
  import emailSentTo from '@/state/emailSentTo'
  import isDisplayEmailSentMessage from '@/state/isDisplayEmailSentMessage'

  // Logic
  import handleEmailSent from '@/logic/contact/handleEmailSent'

  // Translations
  import { useI18n } from 'vue-i18n'
  
export default /*@__PURE__*/_defineComponent({
  __name: 'LoginRegisterResetWrapperBox',
  setup(__props) {

  const { t } = useI18n()

  // Use locale directly from the env to avoid translated locale(ski school etc)
  const locale = window.env.VUE_APP_LOCALE

  // refs
  const emailExists = ref<boolean>(true)

  const handleEmailChange = (newVal: string) => {
    email.value = newVal
  }
  const handleEmailExists = (isEmailExists: boolean) => {
    emailExists.value = isEmailExists
    if (emailExists.value) {
      current_form.value = UserInfoFormEnum.Login
    } else if (!emailExists.value && locale !== 'fr-FR-CSE') {
      // Only show the registration for non cse account
      current_form.value = UserInfoFormEnum.Register
    }

    isDisplayEmailSentMessage.value = false
    emailSentTo.value = ''
  }
  const handleShowDifferentForm = (newVal: UserInfoFormEnum) => {
    current_form.value = newVal
  }

  // Computed

  // Only show the error in case of cse, for other locales we show the register form
  const showNotEmailExistsError = computed<boolean>(() => {
    return !emailExists.value && locale === 'fr-FR-CSE'
  })

  onUnmounted(() => {
    handleShowDifferentForm(UserInfoFormEnum.Check)
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(current_form) !== _unref(UserInfoFormEnum).NewPassword)
        ? (_openBlock(), _createBlock(ContainerBox, {
            key: 0,
            style: {"padding":"20px"}
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                (_unref(current_form) === _unref(UserInfoFormEnum).Check)
                  ? (_openBlock(), _createBlock(CheckForm, {
                      key: 0,
                      email: _unref(email),
                      onEmailChange: _cache[0] || (_cache[0] = (email) => handleEmailChange(email)),
                      onEmailExists: _cache[1] || (_cache[1] = isEmailExists => handleEmailExists(isEmailExists))
                    }, null, 8, ["email"]))
                  : _createCommentVNode("", true),
                (_unref(current_form) === _unref(UserInfoFormEnum).Login)
                  ? (_openBlock(), _createBlock(LoginForm, {
                      key: 1,
                      email: _unref(email),
                      isDisplayEmailSentMessage: _unref(isDisplayEmailSentMessage),
                      emailSentTo: _unref(emailSentTo),
                      onEmailChange: _cache[2] || (_cache[2] = email => handleEmailChange(email)),
                      onResetPassword: _cache[3] || (_cache[3] = 
              () => handleShowDifferentForm(_unref(UserInfoFormEnum).Reset)
            ),
                      onUseOtherEmail: _cache[4] || (_cache[4] = 
              () => handleShowDifferentForm(_unref(UserInfoFormEnum).Check)
            )
                    }, null, 8, ["email", "isDisplayEmailSentMessage", "emailSentTo"]))
                  : _createCommentVNode("", true),
                (_unref(current_form) === _unref(UserInfoFormEnum).Reset)
                  ? (_openBlock(), _createBlock(ResetForm, {
                      key: 2,
                      email: _unref(email),
                      onEmailChange: _cache[5] || (_cache[5] = (email) => handleEmailChange(email)),
                      onEmailSent: _cache[6] || (_cache[6] = () => _unref(handleEmailSent)()),
                      onUseOtherEmail: _cache[7] || (_cache[7] = 
              () => handleShowDifferentForm(_unref(UserInfoFormEnum).Check)
            )
                    }, null, 8, ["email"]))
                  : _createCommentVNode("", true),
                (_unref(current_form) === _unref(UserInfoFormEnum).Register)
                  ? (_openBlock(), _createBlock(RegisterForm, {
                      key: 3,
                      email: _unref(email),
                      onEmailChange: _cache[8] || (_cache[8] = email => handleEmailChange(email)),
                      onUseOtherEmail: _cache[9] || (_cache[9] = 
              () => handleShowDifferentForm(_unref(UserInfoFormEnum).Check)
            )
                    }, null, 8, ["email"]))
                  : _createCommentVNode("", true)
              ]),
              (_unref(loadingSet).size)
                ? (_openBlock(), _createBlock(Overlay, {
                    key: 0,
                    additionalClasses: 'loader'
                  }))
                : _createCommentVNode("", true),
              (showNotEmailExistsError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(Banner, { background: 'var(--orange-100)' }, {
                      text: _withCtx(() => [
                        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(t)('loginRegister.contacts_incorrect_credentials')), 1)
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(NewPasswordForm, { key: 1 }))
    ]),
    (_unref(showResetPopUp))
      ? (_openBlock(), _createBlock(Overlay, {
          key: 0,
          style: {"padding":"20px"},
          isTransitioning: true,
          position: 'fixed',
          background: 'rgba(13, 20, 27, 0.9)',
          zIndex: 9999
        }, {
          default: _withCtx(() => [
            _createVNode(ResetPopUp)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})